import {baseTranslatedEnumValueParams} from './base_translated_enum_value_params';
import {RenderingServices, TranslateEnumParams} from '../types';

export function translatedEnumValueRenderer(params: TranslateEnumParams, services: RenderingServices = {}) {
  const {plainTranslatedValue} = baseTranslatedEnumValueParams(params, services);
  return plainTranslatedValue;
}
